'use strict';
// import './style.css';

export class FormFinishing
{
    constructor(form, link)
    {
        this.form = form;
        this.link = link;

        this.init();
    }

    init()
    {
        const instance = this

        if (this.form) {
            BX.bind(this.form, 'submit', BX.proxy(function(e) {
                instance.sendForm(e)
            }, this.form, this.link))
        }
    }

    sendForm(e) {
        const instance = this
        let form = this.form;
        let link = this.link
        BX.PreventDefault(e);
        form.getElementsByClassName('js-form-errors')[0].innerHTML = '';

        let xhr = new XMLHttpRequest();
        xhr.open('POST', link);

        xhr.onload = function() {
            if (xhr.status !== 200) {
                alert(`Ошибка ${xhr.status}: ${xhr.statusText}`);
            } else {
                var json = JSON.parse(xhr.responseText)

                if (! json.success) {
                    let errorStr = '';
                    for (let fieldKey in json.errors) {
                        errorStr += json.errors[fieldKey] + '<br>';
                    }

                    // Ошибки вывести в элемент с классом error-msg
                    form.getElementsByClassName('js-form-errors')[0].innerHTML = errorStr;
                } else {
                    // Показываем сообщение об успешной отправке
                    // popupSuccess()
                    form.reset()
                    instance.showSuccessMessage()
                    ym(43538829, 'reachGoal', 'form_submit_finishing')
                }
            }
        };

        xhr.onerror = function() {
            alert("Запрос не удался");
        };

        // Передаем все данные из формы
        xhr.send(new FormData(form));
    }

    showErrors(form, data) {
        const formErrors = JSON.parse(JSON.stringify(data.errors));
        for (let i in formErrors) {
            let key = i;
            let errorVal = formErrors[i];

            let errorDiv = document.createElement('div');
            errorDiv.className = "alert js-error";
            errorDiv.innerHTML = errorVal;
            document.body.append(errorDiv);

            if (!form.querySelector('.js-form-errors').contains(form.querySelector('.js-form-errors').querySelector('.js-error')) || errorDiv.textContent !== form.querySelector('.js-form-errors').querySelector('.js-error').textContent) {
                form.querySelector('.js-form-errors').append(errorDiv)
            }
        }
    }

    showSuccessMessage() {
        $('.dialogs .popup').removeClass('active').hide();
        $("#send").show();
        $('.dialogs').addClass('act');
        $('.dialogs').animate({'z-index':99}, 200, function() {
            $("#send").addClass('active');
        });
        $('body').css({'overflow-y':'hidden'});
    }
}